import React from "react";

/** Compact padlock glyph for locked CTAs and badges. */
export default function LockIcon({ className = "lockIcon", title = "Locked" }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            aria-hidden={title ? undefined : true}
            role={title ? "img" : "presentation"}
            focusable="false"
        >
            {title ? <title>{title}</title> : null}
            <path
                d="M7.5 10.25V8.1a4.5 4.5 0 0 1 9 0v2.15"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
            />
            <rect
                x="5.25"
                y="10.25"
                width="13.5"
                height="10"
                rx="2.4"
                fill="currentColor"
            />
            <circle cx="12" cy="14.6" r="1.35" fill="#2a3144" />
            <path
                d="M12 15.7v2.1"
                fill="none"
                stroke="#2a3144"
                strokeWidth="1.8"
                strokeLinecap="round"
            />
        </svg>
    );
}
